import React from 'react';
import { DefaultRecordType } from 'rc-table/lib/interface';

import history from 'browserHistory';

export const StatusCell = (value: any, record: DefaultRecordType) => {
  const pathMode = history.location.pathname.split('/')[1];
  const isDirector = pathMode === 'director';

  return (
    <React.Fragment>
      {value} {record.status.title}{' '}
      {isDirector && record.status.id === 8 && record?.departureSecurityGate
        ? `(${record?.departureSecurityGate})`
        : ''}
    </React.Fragment>
  );
};
